import { Route, Routes } from "react-router-dom";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import ProtectedRoute from "./ProtectedRoute";
import MasterLayout from "../masterLayout/MasterLayout";
import { renderRoutes } from "./routes-roles/RouteRenderer";
import { sharedRoutes } from "./routes-roles/shared.routes";
import { adminRoutes } from "./routes-roles/admin.routes";
import { mentorRoutes } from "./routes-roles/ mentor.routes";
import ErrorPage from "../pages/ErrorPage";
import { studentRoutes } from "./routes-roles/student.routes";
import VerificarEmailPage from "../pages/VerificarEmailPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="/verificar-email" element={<VerificarEmailPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MasterLayout />}>
          {renderRoutes(sharedRoutes)}
          {renderRoutes(adminRoutes)}
          {renderRoutes(mentorRoutes)}
          {renderRoutes(studentRoutes)}
        </Route>
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default AppRoutes;
